const donutChartFills =['#D40511','#6D6D6D'];

const donutChartInfos = [{title:"Rate Agreement",data: [
  { asset: "count", amount: 35 },
    { asset: "remaining", amount: 65 }
  ],totalAgreement:184},{title:"Due Rate Agreement",data: [
    { asset: "count", amount: 24 },
      { asset: "remaining", amount: 76 }
    ],totalAgreement:206},{title:"Draft Rate Agreement",data:[
      { asset: "count", amount: 70 },
        { asset: "remaining", amount: 30 },
      ],totalAgreement:121}]
function getDataForBarChart() {
        return [
          {
            quarter: "Q1'18",
            iphone: 140,
            mac: 100,
            ipad: 80,
          },
          {
            quarter: "Q2'18",
            iphone: 124,
            mac: 90,
            ipad: 100,
          },
          {
            quarter: "Q3'18",
            iphone: 112,
            mac: 95,
            ipad: 90,
          },
          {
            quarter: "Q4'18",
            iphone: 118,
            mac: 24,
            ipad: 14,
          },
        ];
      }
export {donutChartFills,donutChartInfos,getDataForBarChart}